// src/components/Notifications/Notifications.tsx
import MuiAlert, { AlertProps } from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import Stack from '@mui/material/Stack'
import * as React from 'react'

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

export type NotificationType = {
  id: number
  message: string
  severity: 'success' | 'error' | 'warning' | 'info' | undefined
}

interface NotificationsProps {
  notifications: NotificationType[]
  onClose: (id: number) => void
}

export function Notifications({ notifications, onClose }: NotificationsProps) {
  return (
    <Stack spacing={2} sx={{ position: 'fixed', top: '16px', right: '16px', zIndex: 1300 }}>
      {notifications.map(({ id, message, severity }) => (
        <Snackbar
          key={id}
          open
          autoHideDuration={6000}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={() => onClose(id)}
        >
          <Alert severity={severity || 'info'} sx={{ width: '100%' }}>
            {message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  )
}
